import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ViveStatuses } from 'src/app/interfaces/vive-statuses';
import { ViveSubStatuses } from 'src/app/interfaces/vive-sub-statuses';

import { CanadianWorkersCompensationForm } from './canadian-workers-compensation-form';
import { CompanyForm } from './company-form';
import { CompanyVendorOfficeForm } from './company-vendor-office-form';
import { InsuranceCertificateForm } from './insurance-certificate-form';
import { VendorForm } from './vendor-form';

export class CompanyVendorForm extends FormGroup<{
  id: FormControl<number | undefined>;
  CompanyId: FormControl<number | null>;
  VendorId: FormControl<number | null>;
  ExemptVendorId: FormControl<number | null>;
  ClientRegisteredVendorId: FormControl<number | null>;
  viveStatus: FormControl<ViveStatuses | undefined>;
  viveSubStatus: FormControl<ViveSubStatuses | null>;
  statusDate: FormControl<Date | undefined>;
  vendorPaid: FormControl<boolean | undefined>;
  feeWaived: FormControl<boolean | undefined>;
  feeWaivedDate: FormControl<Date | null>;
  isUnFeeWaived: FormControl<boolean | undefined>;
  unFeeWaivedDate: FormControl<Date | null>;
  vendorLastDatePaid: FormControl<Date | null>;
  glIsNamed: FormControl<boolean | undefined>;
  autoIsNamed: FormControl<boolean | undefined>;
  umbIsName: FormControl<boolean | undefined>;
  wkIsNamed: FormControl<boolean | undefined>;
  errIsNamed: FormControl<boolean | undefined>;
  tradeIsNamed: FormControl<boolean | undefined>;
  glDescOps: FormControl<boolean | undefined>;
  autoDescOps: FormControl<boolean | undefined>;
  umbDescOps: FormControl<boolean | undefined>;
  wkDescOps: FormControl<boolean | undefined>;
  errDescOps: FormControl<boolean | undefined>;
  tradeDescOps: FormControl<boolean | undefined>;
  glIsAgency: FormControl<boolean | undefined>;
  autoIsAgency: FormControl<boolean | undefined>;
  umbIsAgency: FormControl<boolean | undefined>;
  wkIsAgency: FormControl<boolean | undefined>;
  errIsAgency: FormControl<boolean | undefined>;
  tradeIsAgency: FormControl<boolean | undefined>;
  overrallVendorRating: FormControl<number | null>;
  CompanyRankingId: FormControl<number | undefined>;
  transitionDate: FormControl<Date | null>;
  isTransitional: FormControl<boolean | undefined>;
  transitionTrades: FormControl<string | null>;
  country: FormControl<'US' | 'CA' | undefined>;
  CAWCNumber: FormControl<string | null>;
  CAWCcertNumber: FormControl<string | null>;
  CAWCStatus: FormControl<'Eligible' | 'Ineligible' | 'Preliminary' | null>;
  CAWCDate: FormControl<Date | null>;
  CAWCExempt: FormControl<boolean | null>;
  lastRenewalAnniversaryDate: FormControl<Date | null>;
  allowEinAutoLink: FormControl<boolean | undefined>;
  isArchived: FormControl<boolean | undefined>;
  isUsingNewBusinessVerification: FormControl<boolean | undefined>;
  isWCExemptValid: FormControl<boolean | null>;
  isWorkersCompExempt: FormControl<boolean | undefined>;
  lastFeeWaivedDate: FormControl<Date | null>;
  useTransporterTrades: FormControl<boolean | undefined>;
  isTollBrothers: FormControl<boolean | undefined>;
  isBusinessRequirementsConfirmed: FormControl<boolean | undefined>;
  isOwnerRequirementsConfirmed: FormControl<boolean | undefined>;
  isInsuranceRequirementsConfirmed: FormControl<boolean | undefined>;
  CompanyComplianceTypeId: FormControl<number | undefined>;
  BundleId: FormControl<number | null>;
  forceTempActive: FormControl<boolean | undefined>;
  lastForceTempActiveDate: FormControl<Date | null | undefined>;
  forceActiveCounter: FormControl<number | undefined>;

  Company?: CompanyForm;
  Vendor?: VendorForm;
  InsuranceCertificates?: FormArray<InsuranceCertificateForm>;
  CanadianWorkersCompensations?: FormArray<CanadianWorkersCompensationForm>;
  CompanyVendorOffices?: FormArray<CompanyVendorOfficeForm>;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      CompanyId: new FormControl<number | null>(null),
      VendorId: new FormControl<number | null>(null),
      ExemptVendorId: new FormControl<number | null>(null),
      ClientRegisteredVendorId: new FormControl<number | null>(null),
      viveStatus: new FormControl<ViveStatuses | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      viveSubStatus: new FormControl<ViveSubStatuses | null>(null),
      statusDate: new FormControl<Date | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      vendorPaid: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      feeWaived: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      feeWaivedDate: new FormControl<Date | null>(null),
      isUnFeeWaived: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      unFeeWaivedDate: new FormControl<Date | null>(null),
      vendorLastDatePaid: new FormControl<Date | null>(null),
      glIsNamed: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      autoIsNamed: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      umbIsName: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      wkIsNamed: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      errIsNamed: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      tradeIsNamed: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      glDescOps: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      autoDescOps: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      umbDescOps: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      wkDescOps: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      errDescOps: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      tradeDescOps: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      glIsAgency: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      autoIsAgency: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      umbIsAgency: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      wkIsAgency: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      errIsAgency: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      tradeIsAgency: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      overrallVendorRating: new FormControl<number | null>(null),
      CompanyRankingId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      transitionDate: new FormControl<Date | null>(null),
      isTransitional: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      transitionTrades: new FormControl<string | null>(null),
      country: new FormControl<'US' | 'CA' | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      CAWCNumber: new FormControl<string | null>(null),
      CAWCcertNumber: new FormControl<string | null>(null),
      CAWCStatus: new FormControl<
        'Eligible' | 'Ineligible' | 'Preliminary' | null
      >(null),
      CAWCDate: new FormControl<Date | null>(null),
      CAWCExempt: new FormControl<boolean | null>(null),
      lastRenewalAnniversaryDate: new FormControl<Date | null>(null),
      allowEinAutoLink: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      isArchived: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      isUsingNewBusinessVerification: new FormControl<boolean | undefined>(
        false,
        { nonNullable: true, validators: [Validators.required] }
      ),
      isWCExemptValid: new FormControl<boolean | null>(null),
      isWorkersCompExempt: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      lastFeeWaivedDate: new FormControl<Date | null>(null),
      useTransporterTrades: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      isTollBrothers: new FormControl<boolean | undefined>(false, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      isBusinessRequirementsConfirmed: new FormControl<boolean | undefined>(
        false,
        { nonNullable: true, validators: [Validators.required] }
      ),
      isOwnerRequirementsConfirmed: new FormControl<boolean | undefined>(
        false,
        { nonNullable: true, validators: [Validators.required] }
      ),
      isInsuranceRequirementsConfirmed: new FormControl<boolean | undefined>(
        false,
        { nonNullable: true, validators: [Validators.required] }
      ),
      CompanyComplianceTypeId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      BundleId: new FormControl<number | null>(null),
      forceTempActive: new FormControl<boolean | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      lastForceTempActiveDate: new FormControl<Date | null | undefined>(null),
      forceActiveCounter: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      )
    });
  }
}

// Need to add some of these form groups.
/*
ExemptVendor?: ExemptVendor | null;
ClientRegisteredVendor?: ClientRegisteredVendor | null;
CompanyVendorFiles?: CompanyVendorFile[];
RegistrationProgresses?: RegistrationProgress[];
SignedDocuments?: SignedDocument[];
CompanyVendorPayments?: CompanyVendorPayment[];
ViveProgresses?: ViveProgress[];
*/
